import React from "react";
import "./MainContentWrapper.css";

/**
 * MainContentWrapper component that adjusts content area based on sidebar width
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Content to be wrapped
 * @param {boolean} props.sidebarCollapsed - Whether the sidebar is collapsed
 * @param {boolean} props.isMobileOpen - Whether mobile sidebar is open
 * @param {boolean} props.hasSidebar - Whether sidebar is present (for authenticated users)
 * @returns {JSX.Element} The wrapped content
 */
const MainContentWrapper = React.memo(function MainContentWrapper({
  children,
  hasSidebar = true,
}) {
  // Calculate the appropriate CSS class based on sidebar presence
  const getContentClass = () => {
    if (!hasSidebar) {
      return "main-content-wrapper no-sidebar";
    }

    return "main-content-wrapper with-sidebar";
  };

  return (
    <div className={getContentClass()}>
      <div className="main-content-inner">{children}</div>
    </div>
  );
});

export default MainContentWrapper;
